export const LEADERBOARD_ACTION_TYPES = {
    FETCH_LEADERBOARD_START: "leaderboard/FETCH_LEADERBOARD_START",
    FETCH_LEADERBOARD_SUCCESS: "leaderboard/FETCH_LEADERBOARD_SUCCESS",
    FETCH_LEADERBOARD_FAILURE: "leaderboard/FETCH_LEADERBOARD_FAILURE",
}